import { useState } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";
import Alert from "components/v2/Alert/Alert";

export default function QuoteTBQRBanner() {
  const intl = useIntl();
  const { id } = useParams();
  const shipmentId = id!;

  const [showAlert, setShowAlert] = useState(true);

  const { data: shipmentData }: any = useGetShipmentBasic(shipmentId, {
    enabled: !!shipmentId,
    refetchOnMount: false,
  });

  const showTBQRAlertCondition = shipmentData?.settings?.tbqr_shipment && showAlert;

  if (!showTBQRAlertCondition) return null;

  return (
    <Alert
      variant="brand"
      label={intl.formatMessage({
        id: "shipment-quotes.components.quotes.TBQRShipmentMessage",
        defaultMessage: "Multiple quotations can be booked",
      })}
      onClose={() => {
        setShowAlert(false);
      }}
    >
      <span>
        {intl.formatMessage({
          id: "shipment-quotes.components.quotes.TBQRShipmentSubMessage",
          defaultMessage: "Booking a quote will create a separate reference number for the booked shipment.",
        })}
      </span>
    </Alert>
  );
}
